import React from "react";
import ReportsSection from "../../components/Investor/Reports.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const Report = () => {
  return (
    <div>
      <MetaComponent
        title="Aptech Investors Reports and Financials."
        desc="Quarterly and annual reports, shareholding patterns, and related press releases of Aptech Ltd, a leading vocational training institute."
        keywords="Quarterly and annual reports of Aptech, Aptech Investor relations, Financial statements of Aptech."
      />
      <ReportsSection />
    </div>
  );
};

export default Report;
